import { createContext, useState } from "react";

export const SelectedDashBoardElements = createContext()

export const SelectedDashBoardElementsProvider = (props) => {
    const [selectedActivity, setSelectedActivity] = useState(null)
    const [selectedActivityTitle, setSelectedActivityTitle] = useState(null);
    const [selectedEffect, setSelectedEffect] = useState(null);
    const [selectedEffectTitle, setSelectedEffectTitle] = useState(null);

    return(
        <SelectedDashBoardElements.Provider value={{selectedActivity, setSelectedActivity, selectedActivityTitle, setSelectedActivityTitle, selectedEffect, setSelectedEffect, selectedEffectTitle, setSelectedEffectTitle}}>
            {props.children}
        </SelectedDashBoardElements.Provider>
    )
}